import { useEffect } from "react";

const BASE = "Glories of India Publications";
const DEFAULT_TITLE = `${BASE} | Books & Civilizational Research`;

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

/**
 * useSEO — sets document.title, meta description, canonical, and Open Graph
 * tags for the lifetime of the calling component. All args optional; missing
 * values fall back to the site-wide default so the head is never blank.
 */
export default function useSEO({ title, description, canonical, socialImage } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} | ${BASE}` : DEFAULT_TITLE;
    if (description) setMeta("description", description);
    if (socialImage) {
      setMeta("og:image", socialImage, "property");
      setMeta("twitter:image", socialImage);
    }
    setMeta("og:title", title ? `${title} | ${BASE}` : DEFAULT_TITLE, "property");
    if (description) setMeta("og:description", description, "property");
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
    return () => { document.title = prevTitle; };
  }, [title, description, canonical, socialImage]);
}
